// extracted by mini-css-extract-plugin
export default {"depositTransfer":"bcgNC","depositTransfer__button":"gfIly"};